import React from 'react';
import styled from '@emotion/styled';

const StyledLoader = styled.div`
	&.overlay {
		position: absolute;
		left: 0;
		top: 0;
		z-index: 2;
		height: 100%;
		background-color: rgba(255, 255, 255, 0.8);
	}
`;

function Loader({ extraClassName = '' }) {
	return (
		<>
			<StyledLoader
				className={
					'loader-new w-100 d-flex justify-content-center align-items-center ' +
					extraClassName
				}
			>
				<svg
					className='loader-new__inner'
					viewBox='0 0 66 66'
					xmlns='http://www.w3.org/2000/svg'
				>
					<circle
						className='loader-new__circle'
						fill='none'
						cx='33'
						cy='33'
						r='30'
					></circle>
				</svg>
			</StyledLoader>
		</>
	);
}

export default Loader;
